/* unplugin-vue-components disabled */import script from "./WxInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./WxInfo.vue?vue&type=script&setup=true&lang=js"

import "./WxInfo.vue?vue&type=style&index=0&id=04d4cee0&lang=scss&scoped=true"

import exportComponent from "D:\\igencloud_team\\ident-doc-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04d4cee0"]])

export default __exports__